import PropTypes from 'prop-types';

const formatError = (error) => {
    if (!error || typeof error !== 'string') return error;

    return error.charAt(0).toUpperCase() + error.slice(1).toLowerCase();
};


// Text under a field: the error replaces the success / helper text (Design System rule)
const ValidationMessage = ({ error, successText, helperText }) => {
    if (error) {
        return (
            <div className="font-normal validation-text">
                {formatError(error)}
            </div>
        );
    }
    if (successText) {
        return <div className="validation-success-text">{successText}</div>;
    }
    if (helperText) {
        return <div className="validation-helper-text">{helperText}</div>;
    }
    return null;
};
ValidationMessage.propTypes = {
    error: PropTypes.string,
    successText: PropTypes.string,
    helperText: PropTypes.string,
};
export default ValidationMessage;
